@if (currentBenefits) {
  <div class="current-deductions-container">
    <div class="current-deductions-title-row">
      <mwp-text-translate [text]="currentBenefits.summaryTotalCards[0].frequencyDisplay | titlecase" [jsonKey]="currentBenefits.summaryTotalCards[0].frequencyDisplay | titlecase" />
      <!-- {{currentBenefits.summaryTotalCards[0].frequencyDisplay | titlecase}} -->
      <mwp-text-translate text="Benefit Deductions" jsonKey="benefitDeductions" />
    </div>
    @if (currentBenefits.summaryBenefitCards.length > 0) {
      <div class="w-100 current-deductions-list-container">
        <div class="current-deductions-list-header">
          <div class="current-benefit-plan">
            <mwp-text-translate  text="Category" jsonKey="category" />
          </div>
          <div class="currentbenefit-plan-total">
            <mwp-text-translate  text="Cost" jsonKey="cost" />
          </div>
        </div>
        @for (benefit of currentBenefits.summaryBenefitCards; track benefit) {
          <div class="current-deductions-list">
            <div class="current-benefit-plan">{{ benefit.enrollmentName | titlecase }}</div>
            <div class="currentbenefit-plan-total">${{ benefit.deductionAmount.toFixed(2) }}</div>
          </div>
        }
      </div>
    } @else {
      <div class="current-deductions-list">
        <mwp-text-translate text="No Current Deductions" jsonKey="noCurrentDeductions" />
      </div>
    }
    <!-- <div class="current-deductions-total-deductions">
    <div class="fw-bold">
      <mwp-text-translate text="TOTAL DEDUCTIONS" jsonKey="totalDeductions" />
    </div>
    <div>
      ${{currentBenefits.summaryTotalCards[0].totalCost.toFixed(2)}}
    </div>
  </div> -->
</div>
}